export default {
    selectedFiscalYear: {},
    fiscalYears: []
};
